import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import ToastNotification from './components/Common/ToastNotification.vue';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import "@/styles/main.css";

function initApp() {
  const savedUser = localStorage.getItem('user');
  const savedToken = localStorage.getItem('token');

  if (savedUser && savedToken) {
    store.commit("auth/setUser", JSON.parse(savedUser));
    store.commit("auth/setToken", savedToken);
  }

  const app = createApp(App);
  app.use(store).use(i18n).use(router);
  app.component('ToastNotification', ToastNotification);
  app.mount('#app');
}

initApp();
